import styled from "styled-components";

export const Wrapper = styled.div``;

export const Sections = styled.div`
  margin: -8px;
  padding: 16px;
  display: flex;
`;

export const SectionWrapper = styled.div`
  padding: 8px;
  flex: 1;
`;

export const Section = styled.fieldset`
  width: 360px;
  border: 1px solid #ccc;
  border-radius: 4px;
`;

export const SectionLabel = styled.legend`
  padding: 0 4px;
  width: auto;
  font-size: 0.9rem;
  color: #555;
  text-align: center;
`;

export const SectionContent = styled.div`
  padding: 8px;
`;

export const InputGroup = styled.div`
  margin-bottom: 8px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 8px;
  &.dropdown-settings {
    flex-direction: column;

    label {
      align-self: flex-start;
    }
  }
`;

export const Label = styled.label`
  margin-bottom: ${(p) => (p.float ? "0" : "4px")};
  display: ${(p) => (p.float ? "inline-block" : "block")};
  font-size: 0.8rem;

  ${(p) =>
    p.float &&
    `
    margin-left: 4px;
  `}
`;

export const Input = styled.input`
  padding: 4px 8px;
  width: 100%;
  height: 32px;
  border: 1px solid #ddd;
  border-radius: 4px;

  &:focus {
    outline: none;
  }
`;

export const Select = styled.select`
  padding: 4px;
  width: 100%;
  height: 32px;
  border: 1px solid #ddd;
  border-radius: 4px;

  &:focus {
    outline: none;
  }
`;

export const Checkbox = styled.input``;

Checkbox.defaultProps = {
  type: "checkbox",
};

export const Buttons = styled.div`
  padding: 16px;
  display: flex;
  justify-content: flex-end;
`;

export const Button = styled.button`
  padding: 4px 8px;
  background: #ddd;
  border: none;
  border-radius: 4px;

  &:focus {
    outline: none;
  }

  &:last-child {
    margin-left: 8px;
  }
`;

export const SliderWrapper = styled.div`
  display: flex;
  width: 100%;
`;

export const Slider = styled.input`
  width: 80%;
  margin-right: 5px;
`;

export const SliderInput = styled.input`
  width: 20%;
  text-align: end;
`;
